import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-page",
  "use": "icon-page-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-page\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 64 192 64C121.6 64 64 121.6 64 192l0 576c0 70.4 57.6 128 128 128l576 0c70.4 0 128-57.6 128-128L896 192C896 121.6 838.4 64 768 64zM640 672c0 17.92-14.08 32-32 32l-320 0C270.08 704 256 689.92 256 672l0 0C256 654.08 270.08 640 288 640l320 0C625.92 640 640 654.08 640 672L640 672zM256 480C256 462.08 270.08 448 288 448l256 0C561.92 448 576 462.08 576 480 576 497.92 561.92 512 544 512l-256 0C270.08 512 256 497.92 256 480zM672 320l-384 0C270.08 320 256 305.92 256 288 256 270.08 270.08 256 288 256l384 0C689.92 256 704 270.08 704 288 704 305.92 689.92 320 672 320z\" p-id=\"9301\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/page.svg
// module id = zrC5
// module chunks = 31